import * as React from 'react';
import { SVGProps } from 'react';

const IconBookmarkFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v22l-9-4-9 4V4Z" />
  </svg>
);
export default IconBookmarkFilledSizeL;
